import _schema from "../schema";
import _str from "../type/str";
import _seq from "../type/seq";
import _map from "../type/map";
var exports = {};
var Schema = _schema;
exports = new Schema({
  explicit: [_str, _seq, _map]
});
export default exports;